module.exports = __webpack_public_path__ + "static/media/Heracross_gaussian2.a59c5bc6.png";